import React from 'react';
import { createQueryParams } from 'features/command-center/services/utils';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { FeatureFlags } from 'UI/constants/featureFlags';

import { EmptyRender, LoadingRender } from '../utils';

import DataTable from './dataTable/DataTable';
import DataTableV2 from './dataTableV2/DataTable';

const Loader = ({ extraColumns, status, week }) => {
  const hasLoadedOptions = !!week && !!status;

  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const renderDataTableV2 = checkIfFeatureFlagEnabled(FeatureFlags.DashboardToolsUsageReportV2);

  const queryParams = createQueryParams({
    week: week?.date,
    extraColumns: extraColumns?.extraColumnsNames,
    status: status?.title
  });
  const dataTableEndpoint = renderDataTableV2
    ? Endpoints.ToolsUsageReportDataV2
    : Endpoints.ToolsUsageReportData;
  const endpoint = hasLoadedOptions ? `${dataTableEndpoint}?${queryParams}` : null;

  const { Status } = useFetchWithStatusV2({
    endpoint,
    apiInstance: renderDataTableV2 ? SECONDARY_API_CLIENT : null
  });

  return (
    <Status
      loading={<LoadingRender />}
      success={data =>
        renderDataTableV2 ? (
          <DataTableV2
            lastUpdates={data?.last_updates}
            items={data?.report}
            queryParams={queryParams}
          />
        ) : (
          <DataTable
            extraColumns={extraColumns}
            items={data?.report}
            lastUpdates={data?.last_updates}
            status={status}
            week={week}
          />
        )
      }
      empty={
        <EmptyRender
          title={strings.feeAgreements.dashboard.title}
          subtitle={strings.feeAgreements.dashboard.subtitle}
        />
      }
      error={() => (
        <EmptyRender
          title={strings.shared.errors.serverError.title}
          subtitle={strings.shared.errors.serverError.subtitle}
        />
      )}
    />
  );
};

export default Loader;
